import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';
import getters from './getters';

const state = {
  contentItemsUrlsChanged: false,
  inProgressContentScrapes: {
    totalStartLength: 0,
    contentItems: [],
  },
  killCurrentScrapingFetch: false,
  scrapingBatchId: 0,
  emailOnCompletion: false,
  newScrapedContent: [],
  newContentItems: [],
  contentEditorArticle: {},
  imageAssetNames: {},
  languages: [],
  contentItemsDisplayProperties: {},
  selectedArticleUuid: '',
  filtersQuery: '', // Delete after part 4
  contentItemsQueryParams: {},
  isLoadingArticles: false,
  loadingArticlesSection: false,
  scrapedContent: [],
  contentItems: [],
  creativeContentStates: [],
  creative: {
    id: 0,
  },
  creatives: [],
  activeCreatives: [],
  creativesSizes: [],
  creativeTemplates: [],
  timestamp: new Date().getTime(),
  contentListType: 'EDITOR',
  page: 1,
  pageSize: 30,
  totalItems: 0,
  totalPages: 1,
  totalPublished: 0,
  feedId: null,
  mode: 'COMMENT',
  currentComments: [],
  commentsCounts: {},
  isSelfServiceContent: true,
  query: '',
  allowAnnotations: false,
  isAddingNewAnnotation: null,
  isTriggeredAnnotation: null,
  isSidebarInputFocused: false,
  currentAnnotation: {},
  creativeShares: {},
  annotations: [],
  sharedCount: 0,
  feedContentItems: [],
  sharedContentItems: [],
  selectedCreativeId: 0,
  selectedCreativeSizeName: '',
  allDisplayCopy: {},
  customPropertyTypes: [],
  creativeBottomPanelIsOpen: false,
  creativeSidebarIsOpen: false,
  contentStates: [],
  adUnitsSelected: ['MEDIUM_RECTANGLE', 'HALF_PAGE', 'BILLBOARD'],
  creativeTypeSelected: null,
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
